import api from "api";
import { useCallback, useEffect, useState } from "react";
import "./profile.scss";

interface State {
    clientId: number;
    projectId: number;
    streamId: number;
    profileId: string;
}

interface InfluencerData {
    profileId: string;
    state: string;
}

interface FacebookReturnObject {
    access_token: string;
    data_access_expiration_time: number;
    expires_in: number;
    long_lived_token: string;
    state: string;
}

interface FacebookPage {
    about: string;
    access_token: string;
    followers_count: number;
    id: string;
    link: string;
    name: string;
    instagram_business_account: InstagramBusinessAccount;
    picture: {
        data: {
            url: string;
        };
    };
}

interface InstagramPage {
    biography: string;
    followers_count: number;
    id: string;
    name: string;
    profile_picture_url: string;
    username: string;
    website: string;
}
interface LinkedInPage {
    name: string;
    accessToken: string;
    urn: string;
    id: string;
}
interface InstagramBusinessAccount {
    id: string;
}

function BrandInfluencer() {
    const [state, setState] = useState<State | null>(null);
    const [token, setToken] = useState<string>("");
    const [pages, setPages] = useState<any[]>([]);
    const [done, setDone] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    const updateProfile = useCallback(
        async (profileId: string, name: string, projectId: number, streamId: number, access_token: string, handle: string, followerCount: number, access_token_secret: string, link: string, image: string, summary: string) => {
            console.log(profileId, name, projectId, streamId, access_token, handle, followerCount, access_token_secret, link, image, summary);
            await api.accessToken.save(profileId, name, projectId, streamId, access_token, handle, followerCount, access_token_secret, link, image, summary);
            setDone(true);
        },
        []
    );

    // FACEBOOK //
    const getFacebookPages = useCallback(async () => {
        const res = await fetch(`https://graph.facebook.com/v18.0/me/accounts?fields=id,about,access_token,description,followers_count,link,name,picture&access_token=${token}`);
        const data: { data: FacebookPage[] } = await res.json();
        let arr: FacebookPage[] = [];
        for (var page of data.data) {
            if (state?.profileId && page.id === state.profileId) {
                setLoading(true);
                arr.push(page);
                // await updateProfile(
                //   page.id,
                //   page.name,
                //   state.projectId,
                //   state.streamId,
                //   token,
                //   page.name,
                //   page.followers_count,
                //   '',
                //   page.link,
                //   page.picture.data.url,
                //   page.about
                // )
                // setDone(true);
            } else {
                arr.push(page);
            }
        }
        setLoading(false);
        setPages(arr);
    }, [state, token, updateProfile]);

    // INSTAGRAM //
    const getInstagramPage = useCallback(
        async (pageId: string): Promise<InstagramPage> => {
            const res = await fetch(`https://graph.facebook.com/v13.0/${pageId}?fields=biography,id,followers_count,name,profile_picture_url,username,website&access_token=${token}`);
            const data = await res.json();
            return data;
        },
        [token]
    );

    const getLinkedInPage = useCallback(
        async (code: string) => {
            let params = new URLSearchParams(window.location.search).entries();
            let returnObject = Object.fromEntries(params);
            let t = JSON.parse(returnObject.state) as State;
            let res = await api.accessToken.getLinkedInPages(code, t.projectId).then(async (data) => {
                console.log(data);
                let arr: LinkedInPage[] = [];
                for (var page of data) {
                    arr.push(page);
                }
                setPages(data);
                setLoading(false);
            });
        },
        [token]
    );

    const getInstagramPages = useCallback(async () => {
        const res = await fetch(`https://graph.facebook.com/v18.0/me/accounts?fields=id,about,access_token,description,followers_count,instagram_business_account,link,name&access_token=${token}`);
        const data: { data: FacebookPage[] } = await res.json();
        let arr: InstagramPage[] = [];
        for (let page of data.data) {
            if (page.instagram_business_account) {
                const instagramPage = await getInstagramPage(page.instagram_business_account.id);
                if (state?.profileId && instagramPage.id === state.profileId) {
                    arr.push(instagramPage);
                    // setLoading(true);
                    // await updateProfile(
                    //   instagramPage.id,
                    //   instagramPage.name,
                    //   state.projectId,
                    //   state.streamId,
                    //   token,
                    //   instagramPage.username,
                    //   instagramPage.followers_count,
                    //   '',
                    //   `https://www.instagram.com/${instagramPage.username}`,
                    //   instagramPage.profile_picture_url,
                    //   instagramPage.biography
                    // )
                    // setDone(true);
                } else {
                    arr.push(instagramPage);
                }
            }
        }
        setPages(arr);
        setLoading(false);
    }, [getInstagramPage, state, token, updateProfile]);

    const getStreamName = useCallback(() => {
        return (
            {
                8: "facebook",
                9: "instagram",
                10: "youtube",
                11: "linkedin",
                12: "tiktok",
            }[state!.streamId] || ""
        );
    }, [state]);

    const selectPage = useCallback(
        async (id: string) => {
            setLoading(true);
            const page = pages.find((x) => x.id === id);
            if (state?.streamId) {
                if (state.streamId === 8) {
                    await updateProfile(page.id, page.name, state.projectId, 8, page.access_token, page.name, page.followers_count, "", page.link, page.picture ? page.picture.data.url : "", page.about);
                } else if (state.streamId === 9) {
                    await updateProfile(
                        page.id,
                        page.name,
                        state.projectId,
                        9,
                        token,
                        page.username,
                        page.followers_count,
                        "",
                        `https://www.instagram.com/${page.username}`,
                        page.profile_picture_url ? page.profile_picture_url : "",
                        page.biography
                    );
                } else if (state.streamId === 11) {
                    await updateProfile(page.id, page.name, state.projectId, 11, page.access_token, page.name, 0, "", `https://www.linkedin.com/organization/${page.id}`, "", "");
                }
            }
            setLoading(false);
        },
        [pages, state?.streamId, state?.projectId, token, updateProfile]
    );

    // const influencerRedirect = useCallback(async (s: State) => {
    //   const origin = window.location.origin.replace('http:', 'https:');
    //   let url = '';
    //   if (s.streamId === 8) {
    //     url = `https://www.facebook.com/v13.0/dialog/oauth?client_id=331970750315107&redirect_uri=${origin}/profile&response_type=token&scope=email,pages_show_list,ads_management,pages_manage_posts,pages_read_engagement&state=${JSON.stringify(s)}`;
    //   } else if (s.streamId === 9) {
    //     url = `https://www.facebook.com/v13.0/dialog/oauth?client_id=756352771097614&redirect_uri=${origin}/profile&response_type=token&scope=pages_show_list,instagram_basic,pages_read_engagement,public_profile,email,instagram_manage_comments,instagram_manage_insights,instagram_content_publish&state=${JSON.stringify(s)}`;
    //   } else if (s.streamId === 11) {
    //     url = `https://www.linkedin.com/uas/oauth2/authorization?client_id=78y7hijgpe4o35&redirect_uri=${origin}/profile&response_type=code&scope=r_basicprofile+r_emailaddress+r_organization_social+w_organization_social+rw_organization_admin+w_member_social&state=${JSON.stringify(s)}`;
    //   }
    //   window.open(url, 'amaSocial - Access Token');
    // }, [])

    useEffect(() => {
        if (token && state) {
            switch (state.streamId) {
                case 8:
                    getFacebookPages();
                    break;
                case 9:
                    getInstagramPages();
                    break;
            }
        }
    }, [token, state, getFacebookPages, getInstagramPages]);

    useEffect(() => {
        let params: IterableIterator<[string, string]>;
        if (window.location.hash) {
            params = new URLSearchParams(window.location.hash.substring(1)).entries();
        } else {
            params = new URLSearchParams(window.location.search).entries();
        }
        let returnObject = Object.fromEntries(params);
        let t = JSON.parse(returnObject.state) as State;
        let at = returnObject.access_token as string;

        if (t.streamId == 8 || t.streamId == 9) {
            setToken(at);
            setState(JSON.parse(returnObject.state));
        } else if (t.streamId == 11) {
            console.log(returnObject);
            setToken(returnObject.code);
            getLinkedInPage(returnObject.code);
            setState(t);
        }
    }, [setState, setToken]);

    return (
        <div className="profile">
            {loading ? (
                <div className="loader">
                    <img src={`${process.env.PUBLIC_URL}/img/Loader.gif`} alt="Loader" />
                </div>
            ) : done ? (
                <div className="done-message">
                    <p>Access token has been granted. You can now close this window.</p>
                    <img src={`${process.env.PUBLIC_URL}/img/success.svg`} alt="" />
                </div>
            ) : (
                <>
                    {pages.length > 0 && (
                        <div className="pages">
                            <h3>Pages</h3>
                            {pages.map((x, i) => {
                                return (
                                    <div onClick={() => selectPage(x.id)} className="page" key={i}>
                                        <div className="picture">
                                            {x.profile_picture_url ? <img src={x.profile_picture_url} alt={x.name} /> : x.picture ? <img src={x.picture.data.url} alt={x.name} /> : <i className={`fab fa-${getStreamName()}`}></i>}
                                        </div>
                                        <p className="name">{x.name}</p>
                                        <button onClick={() => selectPage(x.id)}>Select</button>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default BrandInfluencer;
